import * as firebase from 'firebase';
import { Observer } from 'rxjs/Observer';
import { observeOn } from 'rxjs/operator/observeOn';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { Injectable, Inject } from '@angular/core';
import { FirebaseObjectFactoryOpts, FirebaseAppConfig, FirebaseListFactoryOpts } from 'angularfire2/interfaces';
import * as utils from 'angularfire2/utils';
import { AngularFire, FirebaseObjectObservable, FirebaseApp, FirebaseConfig, FirebaseListFactory, FirebaseListObservable } from 'angularfire2';
import { Storage } from '@ionic/storage';

@Injectable()
export class AngularFireDatabaseWrapper {
	constructor(
		public af: AngularFire,
		public storage: Storage,
		@Inject(FirebaseConfig) private fbConfig: FirebaseAppConfig,
		@Inject(FirebaseApp) private fbApp: any
	) { }
	list(urlOrRef: string | firebase.database.Reference, opts?: FirebaseListFactoryOpts): FirebaseListObservable<any[]> {
		return utils.checkForUrlOrFirebaseRef(urlOrRef, {
			isUrl: () => FirebaseListFactory(this.fbApp.database().refFromURL(getAbsUrl(this.fbConfig, <string>urlOrRef)), opts),
			isRef: () => FirebaseListFactory(<firebase.database.Reference>urlOrRef)
		});
	}
	object(urlOrRef: string, opts?: FirebaseObjectFactoryOpts, firstCache?: boolean): FirebaseObjectObservable<any> {
		return this.FirebaseObjectFactoryFromStorage(this.fbApp.database().refFromURL(getAbsUrl(this.fbConfig, <string>urlOrRef)), opts, firstCache);
	}

	FirebaseObjectFactoryFromStorage(absoluteUrlOrDbRef: string | firebase.database.Reference, { preserveSnapshot }: FirebaseObjectFactoryOpts = {}, firstCache?: boolean): FirebaseObjectObservable<any> {
		let ref: firebase.database.Reference;
		let tsRef: firebase.database.Reference;

		utils.checkForUrlOrFirebaseRef(absoluteUrlOrDbRef, {
			isUrl: () => ref = firebase.database().refFromURL(<string>absoluteUrlOrDbRef),
			isRef: () => ref = <firebase.database.Reference>absoluteUrlOrDbRef
		});

		let absoluteTsRefPath = ref.toString() + '/timestampModified';
		tsRef = firebase.database().refFromURL(<string>absoluteTsRefPath);
		let storageKey = ref.toString().replace(this.fbConfig.databaseURL,'strg').replace('/', ':');

		const objectObservable = new FirebaseObjectObservable((obs: Observer<any>) => {
			let tsFn, fCache= firstCache, firstLoaded = false;
			let self = this;
			if(fCache){
				this.storage.get(storageKey).then(res=>{
					if(res){
						let data = JSON.parse(res);
						firstLoaded = true;
						obs.next(data);
					}
				});
			}
			
			tsFn = tsRef.on('value', (snapshot: firebase.database.DataSnapshot) => {
				this.storage.get(storageKey).then(res => {
					if (res) {
						let data = JSON.parse(res);
						if (/*!data.timestampModified ||*/ (data.timestampModified && data.timestampModified >= snapshot.val())) {
							// console.log('formlocal');
							if(!firstLoaded){
								obs.next(data);
							}
						}
						else {
							loadFromRemote();
						}
					}
					else {
						loadFromRemote()
					}
				});
				function loadFromRemote() {
					firstLoaded = false;
					ref.once('value', (snapshot: firebase.database.DataSnapshot) => {
						let fData = preserveSnapshot ? snapshot : utils.unwrapMapFn(snapshot);
						self.storage.set(storageKey, JSON.stringify(fData));
						// console.log('from remote');
						obs.next(fData);
					});
				}
			});
			


			return () => {
				console.log('off');
				//ref.off('value', fn)
				tsRef.off('value', tsFn);
			};
		}, ref);

		// TODO: should be in the subscription zone instead
		return observeOn.call(objectObservable, new utils.ZoneScheduler(Zone.current));
	}


}
// copy from angularfire
function getAbsUrl(root: FirebaseAppConfig, url: string) {
	if (!(/^[a-z]+:\/\/.*/.test(url))) {
		// Provided url is relative.
		// Strip any leading slash
		url = root.databaseURL + '/' + utils.stripLeadingSlash(url);
	}
	return url;
}




// WEBPACK FOOTER //
// ./src/providers/angularfire-wrapper.ts